<template>
  <div class="upload-contain">
    <van-uploader
      :file-list="picDataList"
      :image-fit="'fit'"
      :show-upload="pictureList.length < maxNum"
      :max-count="maxNum"
      :upload-icon="'plus'"
      :preview-options="{ closeable: true }"
      :multiple="multi"
      :before-read="beforeAvatarUpload"
      :after-read="customUpload"
      :max-size="maxSize * 1024 * 1024"
      @oversize="onOversize"
      @delete="fileDelete"
    />
  </div>
</template>

<script>
import Compressor from 'compressorjs'
import { postUpload } from '@/models/common'
import { Toast } from 'vant'
export default {
  props: {
    maxNum: {
      type: Number,
      default: 1
    },
    multi: {
      type: Boolean,
      default: false
    },
    pictureList: {
      type: Array,
      default: function() {
        return []
      }
    },
    maxSize: {
      type: Number,
      default: 20 // 最大限制20M图片
    }
  },
  data() {
    return {
      picDataList: [] // 图片列表
    }
  },
  watch: {
    'pictureList': function(list) {
      this.picDataList = list
    }
  },
  mounted() {
    this.picDataList = this.pictureList
  },
  methods: {
    // 单图/自定义上传
    async customUpload(option) {
      Toast.loading({
        message: '上传中...',
        forbidClick: true,
      });
      // 多文件上传
      if (Array.isArray(option)) {
        option.map(async (ele) => {
          let newFile = ele.file
          const url = await this.imgUpload(newFile)
          this.picDataList.push({ url: url })
        })
      } else {
        let newFile = option.file
        const url = await this.imgUpload(newFile)
        this.picDataList.push({ url: url })
      }
      Toast.clear()
      this.$emit('success', this.picDataList)
    },
    // 文件上传
    imgUpload(file) {
      return new Promise((resolve, reject) => {
        try {
          const form = new FormData()
          form.append('file', file)
          postUpload(form, {
            type: 'images/yunicu'
          }).then(({data}) => {
            if(data.code == 0) {
                resolve(data.data.url)
            }else {
                this.$toast('上传失败')
                reject(data.message)
            }
          })
        } catch (error) {
          console.error(error)
          this.$toast('上传失败')
        }
      })
    },
    // 启动上传之前
    beforeAvatarUpload(files) {
      // 多文件上传
      if (Array.isArray(files)) {
        const len = files.length
        if (len > this.maxNum) {
          this.$toast(`上传图片数量总数不得超过${this.maxNum}张`)
          return false
        }
        let isCheck = true
        files.map((ele) => {
          if (['image/png', 'image/jpeg', 'image/jpg'].indexOf(ele.type) === -1) {
            this.$toast('支持图片格式为png、jpg')
            isCheck = false
          }
        })
        if (isCheck) {
          return new Promise((resolve, reject) => {
            new Compressor(files, {
              success: resolve,
              error(err) {
                console.log(err.message)
              }
            })
          })
        } else {
          return false
        }
      } else {
        // 单文件上传
        if (['image/png', 'image/jpeg', 'image/jpg'].indexOf(files.type) === -1) {
          this.$toast('支持图片格式为png、jpg')
          return false
        }
        return new Promise((resolve, reject) => {
          new Compressor(files, {
            success: resolve(files),
            error(err) {
              console.log(err.message)
            }
          })

        })
      }
    },
    //
    onOversize() {
      this.$toast(`上传图片不得超过${this.maxSize}M`)
    },
    // 图片删除
    fileDelete(file, detail) {
      this.picDataList.splice(detail.index, 1)
    }
  }
}
</script>

<style lang="less" scoped>
.van-uploader {
  /deep/.van-uploader__upload {
    width: 1.067rem;
    height: 1.067rem;
    margin: 0 0.1rem 0.1rem 0;
  }
  /deep/.van-uploader__upload-icon {
    font-size: 0.4rem;
  }
  /deep/.van-uploader__preview {
    margin: 0 0.1rem 0.1rem 0;
  }
  /deep/.van-uploader__preview-image {
    width: 1.067rem;
    height: 1.067rem;
  }
//   /deep/.van-uploader__preview-delete {
//     width: 0.24rem;
//     height: 0.24rem;
//     .van-uploader__preview-delete-icon {
//       font-size: 0.3rem;
//     }
//   }
}
</style>
